import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { DataWarehouseLinkedService } from '../linkedservice';
import { AzureSqlDWTableDataset } from './azure-sql-dw-table.dataset';
import { GlobalVariables } from '../../constants/globals';

@Metamodel.model({
    name: GlobalVariables.isTrident ? ModelConstants.dataWarehouseTableDataset : ModelConstants.warehouseTableDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.Warehouse_DisplayText),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.Warehouse_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: DataWarehouseLinkedService.MODEL
        }
    }
})
export class DataWarehouseTableDataset extends AzureSqlDWTableDataset {
    public static readonly MODEL: IModel;
}
